const deleteCompaniesStr = {
  toastr: 'Empresa eliminada',
  toastr1: ' eliminada con éxito'
};

export default deleteCompaniesStr;
